// removed by extract-text-webpack-plugin
module.exports = {"home-view":"YOFbewXj","homeView":"YOFbewXj","city-love":"_2Pkjh7Ez","cityLove":"_2Pkjh7Ez","links":"_2ikawM3g","link":"svoZa2zu","icon":"CEG81O62"};


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/HomeView.pcss
// module id = 741
// module chunks = 0